import type { CategoryCardType } from '@/types';
import { Grid, type StyleProp } from '@mantine/core';
import { CategoryCard } from './CategoryCard';
export type UserStatisticProps = {
  items: CategoryCardType[];
  span: StyleProp<number> | undefined;
  isFlex?: boolean;
  itemWidth?: StyleProp<string | number>;
  itemPadding?: StyleProp<string | number>;
  gutter?: StyleProp<number>;
};
export const CategoriesCards: React.FC<UserStatisticProps> = ({
  items,
  span,
  isFlex,
  itemWidth,
  itemPadding,
  gutter
}) => {
  return <Grid gutter={gutter}>
      {items.map(item => <Grid.Col span={span} key={item.id}>
          <CategoryCard {...item} isFlex={isFlex} w={itemWidth} p={itemPadding} />
        </Grid.Col>)}
    </Grid>;
};